import { Pipe, PipeTransform } from '@angular/core';
import { formatDate } from '@angular/common';
import { TranslateService } from '@ngx-translate/core';

@Pipe({
  name: 'dateFormatUTC'
})

export class DateFormatPipeUTC implements PipeTransform {

  constructor(private translateService: TranslateService) {
  }

  public transform(value?: string): string {
    let format;
    let locale;

    try {
      if (value != null) {
        this.translateService.get('date.displayFormat').subscribe(v => { format = v; });
        this.translateService.get('date.locale').subscribe(v => { locale = v; });
        const date = this.parseDate(value);
        var d = formatDate(date, format, locale);
        return d;
      }
      else {
        return "";
      }
    }
    catch {
      return value;
    }
  }

  private parseDate(value: string): Date | null {
    // Check if the format is 'DD/MM/YYYY HH:mm:ss +00:00'
    const isSlashFormat = /^\d{2}\/\d{2}\/\d{4}/.test(value);

    if (isSlashFormat) {
      const [datePart, timePart, offset] = value.split(' ');
      const [month, day, year] = datePart.split('/'); 
      const isoString = `${year}-${month}-${day}T${timePart}`;

      const date = new Date(isoString);
      if (isNaN(date.getTime())) {
        const isoString = `${year}-${day}-${month}T${timePart}`;
        return new Date(isoString);
      } else {
        return date;
      }
    }

    // Assume ISO 8601 format like '2025-22-05T13:38:07+01:00'
    // Split at the 'T' to separate date and time+offset
    const [datePart, timeWithOffset] = value.split('T');
    const timeMatch = timeWithOffset.match(/^([0-9:]+)([+-][0-9:]+)$/);
    const timePart = timeMatch ? timeMatch[1] : '';
    const [month, day, year] = datePart.split('-');
    const isoString = `${year}-${month}-${day}T${timePart}`;

    const date = new Date(isoString);
    if (isNaN(date.getTime())) {
      const isoString = `${year}-${day}-${month}T${timePart}`;
      return new Date(isoString);
    } else {
      return date;
    }
  }

}
